import { LitElement, html, css, svg, nothing } from 'lit-element';
import { customElement, property } from 'lit/decorators.js';
import resetStyle from '../html-content/reset.style';
import { overrideDesignTokens } from '../../styles/override-design-tokens';
import { ludsBaseFont } from '../../styles/typography';
import { i18n } from '../../../i18n/i18n';

@customElement('lua-social-links')
export class LuaSocialLinks extends LitElement {
  static override styles = [
    resetStyle,
    overrideDesignTokens,
    ludsBaseFont,
    css`
      .social-links {
        display: flex;
        gap: var(--spacing-spacing-24);
        padding: 0;
        flex-direction: column;
      }

      .social-link-items {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--spacing-spacing-08);
        border: 1px solid var(--colours-neutrals-gray-500);
        border-radius: var(--corners-m);
        background: none;
        cursor: pointer;
      }

      .social-link-item {
        display: flex;
        align-items: center;
        gap: var(--spacing-spacing-08);
      }

      .social-link {
        color: var(--semantic-colour-tokens-text-text-secondary);
        height: var(--spacing-spacing-24);
        width: var(--spacing-spacing-24);
        text-decoration: none;
      }
    `,
  ];

  @property({ type: Boolean, reflect: true })
  twitterEnabled = false;

  @property({ type: Boolean, reflect: true })
  linkedinEnabled = false;

  shareLinkedIn(e: Event) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent('share-linkedin'));
  }

  shareTwitter(e: Event) {
    e.preventDefault();
    this.dispatchEvent(new CustomEvent('share-twitter'));
  }

  override render() {
    return html`
      <div class="social-links">
        ${this.linkedinEnabled
          ? html`<button class="social-link-items" @click=${this.shareLinkedIn}>
              <div class="social-link-item">
                <a href="#" class="social-link linkedin">
                  ${svg`
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4932_497)">
              <path d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55782 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z" fill="#0A66C2"/>
              </g>
              <defs>
              <clipPath id="clip0_4932_497">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            `}
                </a>
                <span class="social-link-label"
                  >${i18n('lua.share-certificate.share_to_platform', { platform: 'LinkedIn' })}</span
                >
              </div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99927 6.66691C5.82246 6.66691 5.65289 6.73715 5.52786 6.86217C5.40284 6.98719 5.3326 7.15676 5.3326 7.33357V18.0002C5.3326 18.1771 5.40284 18.3466 5.52786 18.4716C5.65289 18.5967 5.82246 18.6669 5.99927 18.6669H16.6659C16.8427 18.6669 17.0123 18.5967 17.1373 18.4716C17.2624 18.3466 17.3326 18.1771 17.3326 18.0002V12.0002C17.3326 11.6321 17.6311 11.3336 17.9993 11.3336C18.3675 11.3336 18.6659 11.6321 18.6659 12.0002V18.0002C18.6659 18.5307 18.4552 19.0394 18.0801 19.4145C17.7051 19.7895 17.1964 20.0002 16.6659 20.0002H5.99927C5.46883 20.0002 4.96013 19.7895 4.58505 19.4145C4.20998 19.0394 3.99927 18.5307 3.99927 18.0002V7.33357C3.99927 6.80314 4.20998 6.29443 4.58505 5.91936C4.96013 5.54429 5.46883 5.33357 5.99927 5.33357H11.9993C12.3675 5.33357 12.6659 5.63205 12.6659 6.00024C12.6659 6.36843 12.3675 6.66691 11.9993 6.66691H5.99927Z"
                  fill="#5F6871" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.666 2.0002C16.666 1.63201 16.9645 1.33354 17.3327 1.33354H21.9993C22.3675 1.33354 22.666 1.63201 22.666 2.0002V6.66687C22.666 7.03506 22.3675 7.33354 21.9993 7.33354C21.6311 7.33354 21.3327 7.03506 21.3327 6.66687V2.66687H17.3327C16.9645 2.66687 16.666 2.36839 16.666 2.0002Z"
                  fill="#5F6871" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.4707 1.5288C22.7311 1.78915 22.7311 2.21126 22.4707 2.47161L13.804 11.1383C13.5437 11.3986 13.1216 11.3986 12.8612 11.1383C12.6009 10.8779 12.6009 10.4558 12.8612 10.1955L21.5279 1.5288C21.7882 1.26845 22.2104 1.26845 22.4707 1.5288Z"
                  fill="#5F6871" />
              </svg>
            </button>`
          : nothing}
        ${this.twitterEnabled
          ? html`<button class="social-link-items" @click=${this.shareTwitter}>
              <div class="social-link-item">
                <a href="#" class="social-link twitter">
                  ${svg`
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.3263 1.90391H21.6998L14.3297 10.3274L23 21.7899H16.2112L10.894 14.8379L4.80995 21.7899H1.43443L9.31743 12.78L1 1.90391H7.96111L12.7674 8.25824L18.3263 1.90391ZM17.1423 19.7707H19.0116L6.94539 3.81704H4.93946L17.1423 19.7707Z" fill="black"/>
              </svg>
            `}
                </a>
                <span class="social-link-label"
                  >${i18n('lua.share-certificate.share_to_platform', { platform: 'X' })}</span
                >
              </div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.99927 6.66691C5.82246 6.66691 5.65289 6.73715 5.52786 6.86217C5.40284 6.98719 5.3326 7.15676 5.3326 7.33357V18.0002C5.3326 18.1771 5.40284 18.3466 5.52786 18.4716C5.65289 18.5967 5.82246 18.6669 5.99927 18.6669H16.6659C16.8427 18.6669 17.0123 18.5967 17.1373 18.4716C17.2624 18.3466 17.3326 18.1771 17.3326 18.0002V12.0002C17.3326 11.6321 17.6311 11.3336 17.9993 11.3336C18.3675 11.3336 18.6659 11.6321 18.6659 12.0002V18.0002C18.6659 18.5307 18.4552 19.0394 18.0801 19.4145C17.7051 19.7895 17.1964 20.0002 16.6659 20.0002H5.99927C5.46883 20.0002 4.96013 19.7895 4.58505 19.4145C4.20998 19.0394 3.99927 18.5307 3.99927 18.0002V7.33357C3.99927 6.80314 4.20998 6.29443 4.58505 5.91936C4.96013 5.54429 5.46883 5.33357 5.99927 5.33357H11.9993C12.3675 5.33357 12.6659 5.63205 12.6659 6.00024C12.6659 6.36843 12.3675 6.66691 11.9993 6.66691H5.99927Z"
                  fill="#5F6871" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M16.666 2.0002C16.666 1.63201 16.9645 1.33354 17.3327 1.33354H21.9993C22.3675 1.33354 22.666 1.63201 22.666 2.0002V6.66687C22.666 7.03506 22.3675 7.33354 21.9993 7.33354C21.6311 7.33354 21.3327 7.03506 21.3327 6.66687V2.66687H17.3327C16.9645 2.66687 16.666 2.36839 16.666 2.0002Z"
                  fill="#5F6871" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.4707 1.5288C22.7311 1.78915 22.7311 2.21126 22.4707 2.47161L13.804 11.1383C13.5437 11.3986 13.1216 11.3986 12.8612 11.1383C12.6009 10.8779 12.6009 10.4558 12.8612 10.1955L21.5279 1.5288C21.7882 1.26845 22.2104 1.26845 22.4707 1.5288Z"
                  fill="#5F6871" />
              </svg>
            </button>`
          : nothing}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'lua-social-links': LuaSocialLinks;
  }
}
